import { OwcChip } from "@one/react";
import { getBookingCategory, getBookingDisplayText } from "./helpFunctions";
import { IconStatus } from "../../constants";

export const BookingTypeChip = ({ item }) => {
  // Get the display text (handles "Assisted Run" case)
  const displayText = getBookingDisplayText(item);

  // Find icon using the display text instead of base category to get the correct icon for Assisted Run
  const bookingIcon =
    IconStatus.find((icon) => icon.text === displayText) ||
    IconStatus.find((icon) => icon.text === getBookingCategory(item.type));

  return (
    <OwcChip
      style={{
        color: bookingIcon.color,
        backgroundColor: bookingIcon.backgroundColor,
      }}
      round
    >
      <strong> {displayText}</strong>
    </OwcChip>
  );
};
